import { Observable } from 'rxjs/Observable';
import { fetchFavorites } from '../utils/api';
import { FavoritesApi } from '../parsers';
import {
  FAVORITES_REQUESTED,
  favoritesSucceeded,
  favoritesRequestFailed,
} from '../redux/favorites';
import type { ActionObs, Store, Obs } from '../types';

export default function favoritesEpic(action$: ActionObs, store: Store): Obs {
  return action$.ofType(FAVORITES_REQUESTED).switchMap(() =>
    fetchFavorites()
      .map(resp => FavoritesApi.parse(resp))
      .map(({ favorites }) => favoritesSucceeded(favorites))
      .catch(err => Observable.of(favoritesRequestFailed(err.message))),
  );
}
